<template>
  <div @click="show_popup" class="box">
    <img class="img" :src="$OSSBaseUrl+'bg8.png'" alt="">
  </div>
</template>
<script>
import { URL5 } from "@/utils/Redirect";
export default {
  name:'TimeOut20210308',
  data(){
    return{}
  },
  methods:{
    show_popup(){
      window.location.href = URL5;
    }
  },
  mounted(){
    let data = {
      page_from:'main_page',
      page_name:'TimeOut',
      page_time:'0.00',
      receiver_id: '',
      page_param:{dayhour:this.$route.query.dayhour,},
    }
    this.$store.dispatch('Public/inH5Record', data)
  },

}
</script>
<style lang="scss" scoped>
  @import 'index.scss';
</style>
